module.exports = __webpack_public_path__ + "assets/discount_disabled-c1a635.svg";